<div class="content-container ">
	<section class="data-table expenses">
		<header class="data-table__header">
			<h1 class="page-heading">
				<svg width="40" height="40" viewBox="0 0 40 40">
					<g fill-rule="evenodd">
						<path d="M25.245 13.141c-8.487 0-12.926-2.08-12.926-3.194V7.36c2.556 1.631 7.763 2.474 12.926 2.474S35.615 8.99 38.17 7.36v2.587c0 1.115-4.44 3.194-12.926 3.194zm0 4.831c-.491 0-.974-.01-1.452-.024a13.514 13.514 0 0 0-4.805-3.624c1.965.287 4.114.433 6.257.433 5.163 0 10.37-.843 12.926-2.474v2.495c0 1.115-4.44 3.194-12.926 3.194zm1.141 4.817a13.204 13.204 0 0 0-1.412-3.204l.27.003c5.164 0 10.37-.843 12.927-2.474v2.495c0 1.064-4.044 3.003-11.785 3.18zm.474 4.815c.032-.374.052-.752.052-1.135 0-.706-.057-1.399-.164-2.075 4.647-.147 9.115-.977 11.423-2.45v2.496c0 1.014-3.881 2.913-11.311 3.164zM13.456 38.181c-6.524 0-11.832-5.254-11.832-11.712 0-6.459 5.308-11.712 11.832-11.712 6.524 0 11.832 5.253 11.832 11.712 0 6.458-5.308 11.712-11.832 11.712zm-1.137-25.898c.506.323 1.117.615 1.81.875a13.622 13.622 0 0 0-.673-.017c-.383 0-.762.02-1.137.051v-.91zM25.245 1.832c8.487 0 12.926 2.078 12.926 3.193 0 1.115-4.44 3.193-12.926 3.193-8.487 0-12.926-2.078-12.926-3.193 0-1.115 4.44-3.193 12.926-3.193zm14.55 3.193c0-3.157-7.32-4.809-14.55-4.809-7.231 0-14.55 1.652-14.55 4.809 0 .143.02.281.049.417h-.05v7.983C4.595 14.69 0 20.057 0 26.469c0 7.348 6.037 13.328 13.456 13.328 6.465 0 11.877-4.54 13.164-10.569 6.49-.187 13.176-1.727 13.176-4.788V5.442h-.05c.03-.136.05-.274.05-.417z" />
						<path d="M14.124 25.504c-1.815-.747-2.587-1.287-2.587-2.367 0-.83.604-1.784 2.211-1.784 1.336 0 2.192.456 2.63.705l.522-1.37c-.606-.353-1.461-.685-2.713-.726v-2.014h-1.294v2.097c-1.92.312-3.152 1.619-3.152 3.342 0 1.805 1.315 2.76 3.444 3.59 1.545.623 2.359 1.329 2.359 2.47 0 1.183-1.003 2.034-2.484 2.034a5.58 5.58 0 0 1-3.005-.892l-.5 1.391c.729.518 1.982.892 3.192.913v2.097h1.315v-2.16c2.15-.352 3.296-1.888 3.296-3.528 0-1.847-1.085-2.926-3.234-3.798" />
					</g>
				</svg>
				<ng-container i18n="@@expenses.expenses">Expenses</ng-container>
			</h1><!-- data-table__heading -->
			<div class="payment-info payment-info--expenses">
				<div class="payment-item">
					<span class="label" i18n="@@expenses.total_expenses">Total Expenses</span>
					<div class="payAmount">
						<div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
						<div class="amountNum">{{ totalSum }}</div>
					</div>
				</div>
			</div><!-- end payment-info -->
		</header>
		<!-- end billing-header -->
		<div class="data-table__wrap expense-controls">
			<div class="data-table__wrap">
				<header class="data-table__create-section">
					<div class="search-field">
						<div class="search-icon">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
									<circle cx="7" cy="7" r="7" />
									<path stroke-linecap="square" d="M13.5 12.5L18 17" />
								</g>
							</svg>
						</div>
						<input type="text" (keyup)="searchExpenses($event.target.value)" name="data-table__search--input"
							i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput>
					</div>
					<div class="create-download">
						<a href="javascript:void(0);" (click)="openAddExpenseModal()" id="tax-details" data-toggle="modal"
							data-target="#taxdetails" class="tu-btn pink add-button">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12" />
								</g>
							</svg>
							<span i18n="@@expenses.create_new_expense">Create new expense</span>
						</a>
						<a href="javascript:void(0);" class="downloadXl" (click)="exportXls()">
							<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
								<g fill="#0CC5D1" fill-rule="evenodd">
									<path
										d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z" />
									<path
										d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z" />
								</g>
							</svg>
							<span i18n="@@common.download_xls">download .xls</span>
						</a>
					</div>
				</header>

				<div class="data-table__filter">
					<div class="top-filter">
						<div class="left-section">
							<span class="show-text" i18n="@@common.show">Show</span>
							<div class="select-pages">
								<select nice-select (change)="switchTab($event.target.value)" id="tab-links-select">
									<option [value]="'all'" [selected]="activeTab == 'all'" i18-data-display="@@expenses.all"
										data-display="All" i18n="@@expenses.all">All</option>
									<ng-container *ngFor="let type of expenseTypes">
										<option [value]="type.value" [selected]="activeTab == type.value">{{ type.label }}</option>
									</ng-container>
								</select>
							</div>
						</div>

						<div class="right-section">
							<a href="javascript:void(0);" class="filters_block_btn filters_options" (click)="toggleFilter()">
								<svg _ngcontent-aii-c108="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="static"><path _ngcontent-aii-c108="" d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
								<span i18n="@@common.filters">Filters</span>
							</a>
						</div>
					</div>

					<div class="body-filter" [class.show]="isFilter">
						<fieldset class="date sl">
							<label i18n="@@common.from_date">From Date</label>
							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()"
									data-dd-init-set="false" i18n-placeholder="@@common.from_date" placeholder="From Date"
									class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="expense-date-range" />
							</div>
						</fieldset>

						<fieldset class="date sl">
							<label i18n="@@common.to_date">To Date</label>
							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()"
									data-dd-init-set="false" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input"
									data-dd-format="d/m/Y" data-dd-roundtrip="expense-date-range" />
							</div>
						</fieldset>

						<fieldset class="md">
							<label i18n="@@common.type">Type</label>
							<select nice-select [(ngModel)]="subjectToVat" (change)="filterExpenses()" i18-placeholder="Select Type">
								<option i18-data-display="@@expenses.type" data-display="Select Type"></option>
								<ng-container *ngFor="let type of filterTypes">
									<!-- printing categories -->
									<ng-container *ngFor="let category of type.categories">
										<option [value]="category.value">{{ category.label }}</option>
									</ng-container>
									<!-- end categories here -->
								</ng-container>
							</select>
						</fieldset>

						<fieldset class="md">
							<label i18n="@@common.minimum_amount">Minimum amount</label>
							<div class="tag-input">
								<input type="text" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="100" />
								<span [innerHtml]="userInfo?.currency_symbol"></span>
							</div>
						</fieldset>

						<fieldset class="md">
							<label i18n="@@common.maximum_amount">Maximum amount</label>
							<div class="tag-input">
								<input type="text" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="10,000" />
								<span [innerHtml]="userInfo?.currency_symbol"></span>
							</div>
						</fieldset>
						<fieldset class="filters_expanded_bottom w-auto">
							<button class="clear_allfilters py-4" (click)="clearAllFilter()">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
									<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								Clear all
							</button>
						</fieldset>
					</div>
				</div>

				<div class="tab-content data-table__tab-content" id="pills-tabContent">

					<div class="tab-pane fade show active" id="pills-projectExpenses" role="tabpanel"
						aria-labelledby="pills-projectExpenses-tab">
						<expenses-table (perPageItems)="onChangePerPageItems($event)" [invoicesList]="invoices" [isProPlan]="isProPlan()" [userInfo]="userInfo"
							(onChange)="onChangeExpense($event)" #expensesTableRef></expenses-table>
					</div>
					<!-- end #projectExpenses -->
				</div>

			</div>
		</div>
		<!-- end data-table__wrap -->
	</section>
	<!-- end data-table -->
</div>
<!-- end content-container -->